import React from 'react';
import { Price } from './styles';

export default class PriceDiff extends React.Component {

  render = () => <Price>{this.toMillion(this.props.priceDiff)}</Price>;

  toMillion = (price) => `${(price / 1e6).toFixed(1).replace(/\.0+$/,'')}M`;

}



// WEBPACK FOOTER //
// ./src/components/AdList/components/Ad/components/PriceDiff/index.js